import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { KioskPromoSelectProductPageConfig } from '@front-platform/content-builder';
import { kioskPromoSelectProductPageResolveConfig } from '@front-platform/content-builder';
import { Component, HostBinding, inject, input } from '@angular/core';
import {
  IContentBuilderFieldColor,
  IContentBuilderFieldImage,
} from '@core/models/content-builder-fields.model';
import { LinkNavigationService } from '@core/services/link-navigation/link-navigation.service';
import { AnalyticsService } from '@core/services/app/analytics.service';
export interface KioskPromoSelectProductPageRuntimeConfig {
  'header'?: any;
  'body'?: any;
  'footer'?: any;
}

export type KioskPromoSelectProductPageConfigInput = Partial<
  Omit<KioskPromoSelectProductPageConfig, keyof KioskPromoSelectProductPageRuntimeConfig> &
    KioskPromoSelectProductPageRuntimeConfig
>;
export type KioskPromoSelectProductPageResolvedConfig = Omit<
  KioskPromoSelectProductPageConfig,
  keyof KioskPromoSelectProductPageRuntimeConfig
> &
  Partial<KioskPromoSelectProductPageRuntimeConfig>;
export interface KioskPromoSelectProductPageContract extends ConfigComponentContract<
  KioskPromoSelectProductPageConfigInput,
  KioskPromoSelectProductPageResolvedConfig
> {}

@Component({
  selector: 'app-kiosk-promo-select-product-page',
  templateUrl: './kiosk-promo-select-product-page.component.html',
  standalone: false,
})
export class KioskPromoSelectProductPageComponent implements KioskPromoSelectProductPageContract {
  readonly config = input<KioskPromoSelectProductPageConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    KioskPromoSelectProductPageConfig,
    KioskPromoSelectProductPageRuntimeConfig
  >(kioskPromoSelectProductPageResolveConfig, () => ({ config: this.config() }));
  get header(): any {
    return this.resolvedConfig()['header'] as unknown as any;
  }
  get body(): any {
    return this.resolvedConfig()['body'] as unknown as any;
  }
  get footer(): any {
    return this.resolvedConfig()['footer'] as unknown as any;
  }

  get backgroundColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['background_color'] as unknown as
      IContentBuilderFieldColor | undefined;
  }
  get backgroundImage(): IContentBuilderFieldImage | undefined {
    return this.resolvedConfig()['background_image'] as unknown as
      IContentBuilderFieldImage | undefined;
  }
  get textColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['text_color'] as unknown as IContentBuilderFieldColor | undefined;
  }
  get linkUrl(): string | undefined {
    return this.resolvedConfig()['link_url'] as unknown as string | undefined;
  }

  @HostBinding('class') classes = 'h-screen flex';

  private readonly linkNavigationService = inject(LinkNavigationService);

  constructor(private readonly analyticsService: AnalyticsService) {}

  get hasBackgroundImage(): boolean {
    return !!this.backgroundImage?.url;
  }

  getBackgroundStyles() {
    const url = this.backgroundImage?.url;
    return {
      'background-image': url ? `url(${url})` : null,
      'background-size': url ? 'cover' : null,
      'background-position': url ? 'center' : null,
      'background-repeat': url ? 'no-repeat' : null,
    };
  }

  back(): void {
    this.linkNavigationService.navigate(this.linkUrl || '/cart');
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(KioskPromoSelectProductPageComponent, {
  'keyAliases': {},
});
